/**
 * @prettier
 */
export function sortOrdersByCreatedAt(orderA: any, orderB: any): any {
    return (new Date(orderA.createdAt) as any) - (new Date(orderB.createdAt) as any);
}
